import { useState, useEffect } from 'react';
import Pagination from '../CustomComponent/Pagination';
import RowCustom from '../CustomComponent/CustomRow';
import { ENDPOINT } from '../../helpers/Constants'
import { web } from '../../helpers/api';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faTrash } from '@fortawesome/free-solid-svg-icons';
function DettaglioQuestionario(props) {
    const [domanderisposte, setDomanderisposte] = useState([]);
    useEffect(() => {
        fetchDomandeRisposte();
    }, [props.key]);
    const fetchDomandeRisposte = async () => {
        let id = window.location.pathname.split('/').pop();
        id = parseInt(id);
        await web.post(ENDPOINT.GETDOMANDERISPOSTA, { idQuestionario: props.dettaglioQuestionario.idQuestionario, idPaziente: id })
            .then((response) => {
                if (response.status === 200 && response.data.dati != null) {
                    setDomanderisposte(response.data.dati);
                }
            }).catch((error) => {
                console.error("Error fetching data", error);
            });
    };

    return (<>
        <div className="container" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h2 className="text-center">Questionario domande e risposte</h2>
            <Row className='pb-5'>
                <Col className="d-flex justify-content-start">
                    <Button variant="primary" onClick={props.mostralistaQuestionari}>
                        <FontAwesomeIcon icon={faArrowCircleLeft} />
                    </Button>
                </Col>
            </Row>
            {domanderisposte?.map((pa) =>
                <>
                    <Row >
                        <Col><h4 className="font-weight-bold"> {pa.domanda} :</h4> </Col>
                        <Col><p>{pa.risposta}</p></Col>
                    </Row>
                    <hr />
                </>

            )
            }
        </div>
    </>
    );
}
export default DettaglioQuestionario; 